<div class="chat-info" [ngStyle]="{ background: 'var(--p-content-background)' }">
  <div
    class="shrink-0 w-full overflow-hidden flex flex-row justify-center items-center"
    [ngStyle]="{ height: (config()?.titleHeight ?? 88) + 'px' }"
  >
    <div class="flex flex-col justify-center h-full ml-[32px] grow overflow-hidden" data-e2e="info-title">
      <div
        class="max-h-full text-color font-normal text-ellipsis overflow-hidden whitespace-nowrap"
        [ngStyle]="{ fontSize: (config()?.titleFontSize ?? 24) + 'px' }"
      >
        {{ title() }}
      </div>
    </div>
    @if (isStream() && config()?.editStreamButton) {
      <button
        [attr.aria-label]="'cl_chat.edit' | translate"
        class="h-[32px] w-[32px] bg-surface-100 rounded-full cursor-pointer ml-[8px] shrink-0 border-none flex items-center justify-center hover:bg-primary/5 focus-visible:shadow-[0_0_0_3px_rgba(0,115,208,0.24)]"
        (click)="editStream()"
        data-e2e="info-edit"
      >
        <i class="mi2-edit text-[16px] text-surface-600"></i>
      </button>
    }
    <mi-round-button
      size="md"
      icon="mi2-close"
      [ariaLabel]="'cl_chat.close' | translate"
      [tooltip]="'cl_chat.close' | translate"
      tooltipPosition="top"
      styleClass="ml-[8px] mr-[16px]"
      (clicked)="close()"
      data-e2e="info-close"
    ></mi-round-button>
  </div>
  <div #infoContent class="info-content">
    <!-- one or two participants in direct  -->
    @if (isDirect()) {
      <div class="pt-[32px] pb-[14px] pl-[32px]">
        @for (p of participantsList(); track p) {
          <div>
            @if ((participantTotal() === 2 && p != chatAuthService.userId) || participantTotal() === 1) {
              <div>
                @if (p === smsParticipant()?.userId) {
                  <mi-avatar
                    class="mb-[32px] shrink-0"
                    [photoUrl]="'assets/images/cl-chat/sms.svg' | chatAssetUrl"
                    styleClass="!w-[72px] !h-[72px]"
                  >
                  </mi-avatar>
                  <div class="text-[16px] font-semibold overflow-hidden text-ellipsis text-muted-color" [title]="p">
                    {{ p }}
                  </div>
                } @else {
                  <mi-avatar
                    class="mb-[32px] shrink-0"
                    [hash]="p | hash"
                    [name]="chatAdminService.displayNames[p]"
                    [initials]="chatAdminService.displayNames[p] | initials"
                    [photoUrl]="
                      chatAdminService.avatars[p]?.hasOwnProperty('150') ? chatAdminService.avatars[p][150] : ''
                    "
                    styleClass="!w-[72px] !h-[72px] !text-3xl"
                  >
                  </mi-avatar>
                  <div
                    class="text-[16px] font-semibold overflow-hidden text-ellipsis text-color"
                    [title]="chatAdminService.displayNames[p]"
                  >
                    {{ chatAdminService.displayNames[p] }}
                  </div>
                }
                @if (config()?.singleParticipantReason) {
                  <div
                    class="text-[14px] overflow-hidden text-ellipsis pointer-events-none text-color"
                    [title]="config()?.singleParticipantReason"
                  >
                    {{ config()?.singleParticipantReason }}
                  </div>
                }
                @if (p !== smsParticipant()?.userId) {
                  <div class="text-[14px] overflow-hidden text-ellipsis mt-[24px] font-semibold text-color">
                    &#64;{{ chatAdminService.displayNames[p] }}
                  </div>
                }
                @if (chatAdminService.extensions[p]) {
                  <div
                    class="text-[14px] overflow-hidden text-ellipsis"
                    [tabindex]="config()?.activatePhoneClick ? 0 : -1"
                    [attr.role]="config()?.activatePhoneClick ? 'button' : null"
                    title="{{
                      'cl_chat.extensionAbbreviation' | translate: { number: chatAdminService.extensions[p] }
                    }}"
                    (click)="callClick(chatAdminService.extensions[p])"
                    (keydown.enter)="callClick(chatAdminService.extensions[p])"
                    (keydown.space)="$event.preventDefault(); callClick(chatAdminService.extensions[p])"
                    [ngClass]="
                      config()?.activatePhoneClick
                        ? 'text-primary cursor-pointer w-fit hover:text-primary-700 dark:hover:text-primary-300 focus-visible:shadow-[0_0_0_2px_rgba(0,115,208,0.24)] focus-visible:rounded-[2px]'
                        : 'pointer-events-none text-color'
                    "
                    data-e2e="info-extension"
                  >
                    {{ 'cl_chat.extensionAbbreviation' | translate: { number: chatAdminService.extensions[p] } }}
                  </div>
                }
                @if (chatAdminService.emails[p]) {
                  <div class="text-[14px] overflow-hidden text-ellipsis mt-[24px] font-semibold text-color">
                    {{ 'cl_chat.emailAddress' | translate | uppercase }}
                  </div>
                }
                <div
                  class="text-[14px] overflow-hidden text-ellipsis"
                  [tabindex]="config()?.activateEmailClick ? 0 : -1"
                  [attr.role]="config()?.activateEmailClick ? 'button' : null"
                  title="{{ chatAdminService.emails[p] }}"
                  (click)="emailClick(chatAdminService.emails[p])"
                  (keydown.enter)="emailClick(chatAdminService.emails[p])"
                  (keydown.space)="$event.preventDefault(); emailClick(chatAdminService.emails[p])"
                  [ngClass]="
                    config()?.activateEmailClick
                      ? 'text-primary cursor-pointer w-fit hover:text-primary-700 dark:hover:text-primary-300 focus-visible:shadow-[0_0_0_2px_rgba(0,115,208,0.24)] focus-visible:rounded-[2px]'
                      : 'pointer-events-none text-color'
                  "
                  data-e2e="info-email-address"
                >
                  {{ chatAdminService.emails[p] }}
                </div>
                @if (chatAdminService.phoneNumbers[p]) {
                  <div class="text-[14px] overflow-hidden text-ellipsis mt-[24px] font-semibold text-color">
                    {{ 'cl_chat.workNumber' | translate | uppercase }}
                  </div>
                  <div
                    class="text-[14px] overflow-hidden text-ellipsis"
                    [tabindex]="config()?.activatePhoneClick ? 0 : -1"
                    [attr.role]="config()?.activatePhoneClick ? 'button' : null"
                    title="{{ chatAdminService.phoneNumbers[p] }}"
                    (click)="callClick(chatAdminService.phoneNumbers[p])"
                    (keydown.enter)="callClick(chatAdminService.phoneNumbers[p])"
                    (keydown.space)="$event.preventDefault(); callClick(chatAdminService.phoneNumbers[p])"
                    [ngClass]="
                      config()?.activatePhoneClick
                        ? 'text-primary cursor-pointer w-fit hover:text-primary-700 dark:hover:text-primary-300 focus-visible:shadow-[0_0_0_2px_rgba(0,115,208,0.24)] focus-visible:rounded-[2px]'
                        : 'pointer-events-none text-color'
                    "
                    data-e2e="info-work-number"
                  >
                    {{ chatAdminService.phoneNumbers[p] }}
                  </div>
                }
                @if (chatAdminService.mobileNumbers[p]) {
                  <div class="text-[14px] overflow-hidden text-ellipsis mt-[24px] font-semibold text-color">
                    {{ 'cl_chat.mobileNumber' | translate | uppercase }}
                  </div>
                  <div
                    class="text-[14px] overflow-hidden text-ellipsis"
                    [tabindex]="config()?.activatePhoneClick ? 0 : -1"
                    [attr.role]="config()?.activatePhoneClick ? 'button' : null"
                    title="{{ chatAdminService.mobileNumbers[p] }}"
                    (click)="callClick(chatAdminService.mobileNumbers[p])"
                    (keydown.enter)="callClick(chatAdminService.mobileNumbers[p])"
                    (keydown.space)="$event.preventDefault(); callClick(chatAdminService.mobileNumbers[p])"
                    [ngClass]="
                      config()?.activatePhoneClick
                        ? 'text-primary cursor-pointer w-fit hover:text-primary-700 dark:hover:text-primary-300 focus-visible:shadow-[0_0_0_2px_rgba(0,115,208,0.24)] focus-visible:rounded-[2px]'
                        : 'pointer-events-none text-color'
                    "
                    data-e2e="info-mobile-number"
                  >
                    {{ chatAdminService.mobileNumbers[p] }}
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    }
    <!-- more than two participants in direct -->
    @if (isGroupDirect() || isOneToOneChat()) {
      <div class="pb-[14px]">
        @for (a of about(); track $index; let i = $index) {
          <div class="mt-[14px] ml-[32px] mr-[30px]">
            <div class="text-[14px] font-semibold uppercase mt-[24px] text-color">
              {{ a.title }}
            </div>
            <div class="break-words mt-[3px] text-[14px] whitespace-pre-wrap text-color">
              {{ a.description }}
            </div>
          </div>
        }
      </div>
    }
    <!-- stream conversation -->
    @if (about() && isStream()) {
      <div class="pb-[14px]">
        @for (a of about(); track $index; let i = $index) {
          <div class="mt-[14px] ml-[32px] mr-[30px]">
            <div
              class="font-semibold text-color"
              [ngClass]="i === 0 ? 'text-[16px] mt-0 break-words normal-case' : 'text-[14px] uppercase mt-[24px]'"
            >
              {{ a.title }}
            </div>
            <div class="break-words mt-[3px] text-[14px] whitespace-pre-wrap text-color">
              {{ a.description }}
            </div>
          </div>
        }
      </div>
    }
    <!-- info about buttons -->
    @if (aboutButtons()) {
      <div class="info-about-buttons">
        @for (a of aboutButtons(); track a.key) {
          <span [pTooltip]="a.tooltip" tooltipPosition="top" appendTo="body" class="mr-[14px]">
            <mi-round-button
              size="md"
              color="primary"
              [icon]="a.icon"
              [ariaLabel]="a.tooltip"
              (clicked)="infoAboutButtonClick(a.key)"
              [attr.data-e2e]="'info-about-' + a.key | slugify"
            ></mi-round-button>
          </span>
        }
      </div>
    }
    <div class="w-full h-px mt-1.5 bg-surface-950/10"></div>
    <div class="w-full h-px mb-1.5 bg-surface-0/80"></div>
    <!-- accordion buttons -->
    @if (buttons()) {
      <p-accordion class="info-button">
        @for (b of currentButtons(); track trackByFn(i, b); let i = $index) {
          <p-accordion-panel
            [value]="i"
            (click)="selectButton(i)"
            (keydown.enter)="selectButton(i)"
            [attr.data-e2e]="'info-acccordion-' + b.type | slugify"
          >
            <p-accordion-header class="info-button-el" [style.fill]="'var(--p-text-color)'">
              <div class="info-button-image">
                @if (b.imgSrc) {
                  <img src="{{ b.imgSrc }}" alt="" class="w-5 h-5 object-contain" />
                } @else if (b.icon) {
                  <i class="{{ b.icon }} text-[20px]"></i>
                }
              </div>
              <div class="info-button-text" title="{{ b.title }}">
                {{ b.title }}
              </div>
              @if (b.type === buttonTypes.PARTICIPANTS && participantsLoaded()) {
                <div class="info-button-members" [title]="getInfoButtonMembersText(b)">
                  {{ getInfoButtonMembersText(b) }}
                </div>
              }
            </p-accordion-header>
            <p-accordion-content>
              <!-- expanded members list -->
              @if (
                b.type === buttonTypes.PARTICIPANTS &&
                participantsLoaded() &&
                selectedConfig()?.type === buttonTypes.PARTICIPANTS
              ) {
                <div>
                  <div [ngStyle]="{ height: '15.625rem' }">
                    <cdk-virtual-scroll-viewport
                      role="list"
                      [attr.aria-label]="'cl_chat.participants' | translate"
                      [ngStyle]="{ height: '100%' }"
                      [itemSize]="50"
                      (scrolledIndexChange)="participantScrolledIndexChanged($event)"
                    >
                      <div role="listitem" *cdkVirtualFor="let p of participantsList()">
                        <div
                          tabindex="0"
                          role="button"
                          [ngClass]="{ pointer: config()?.showParticipantPointer }"
                          (click)="participantClicked(p)"
                          (keydown.enter)="participantClicked(p)"
                          (keydown.space)="$event.preventDefault(); participantClicked(p)"
                          class="info-selected-participant"
                          data-e2e="info-selected-participant"
                        >
                          @if (p === smsParticipant()?.userId) {
                            <mi-avatar
                              [photoUrl]="'assets/images/cl-chat/sms.svg' | chatAssetUrl"
                              styleClass="!w-[30px] !h-[30px] "
                            >
                            </mi-avatar>
                            <div class="participant-name" [ngStyle]="{ 'color': 'var(--p-text-color)' }" [title]="p">
                              {{ p }}
                            </div>
                          } @else {
                            <mi-avatar
                              [hash]="p | hash"
                              [name]="chatAdminService.displayNames[p]"
                              [initials]="chatAdminService.displayNames[p] | initials"
                              [photoUrl]="imageSource(p)"
                              styleClass="!w-[30px] !h-[30px] !text-xs"
                            >
                            </mi-avatar>
                            <div
                              class="participant-name"
                              [title]="chatAdminService.displayNames[p]"
                              [ngStyle]="{ 'color': 'var(--p-text-color)' }"
                            >
                              {{ chatAdminService.displayNames[p] }}
                            </div>
                          }
                        </div>
                      </div>
                    </cdk-virtual-scroll-viewport>
                  </div>
                  @if (config()?.addPeopleButton && isStream()) {
                    <button
                      tabindex="0"
                      (click)="actionClick('invite')"
                      (keydown.enter)="actionClick('invite')"
                      class="chat-one-app-button primary-blue"
                      data-e2e="info-add-people"
                    >
                      {{ 'cl_chat.addPeople' | translate }}
                    </button>
                  }
                </div>
              }
              <!-- expanded attachments list -->
              @if (
                b.type === buttonTypes.ALL_ATTACHMENTS &&
                (selectedConfig()?.type === buttonTypes.ALL_ATTACHMENTS ||
                  selectedConfig()?.type === buttonTypes.IMAGES)
              ) {
                <div
                  [ngStyle]="{
                    height:
                      attachments.length && attachments.length <= 5 ? (attachments.length * 75) / 14 + 'rem' : 'initial'
                  }"
                >
                  @if ((!attachments || attachments.length === 0) && attachmentsLoaded()) {
                    <div class="info-no-files">
                      <i class="mi2-folder-search text-[168px]"></i>
                      <div>{{ 'cl_chat.notAnyFiles' | translate }}</div>
                      <div>{{ 'cl_chat.dragAndDropFiles' | translate }}</div>
                    </div>
                  }
                  @if (attachments && attachments.length > 0 && attachmentsLoaded()) {
                    <cdk-virtual-scroll-viewport
                      [ngStyle]="{ height: attachments && attachments.length <= 5 ? '100%' : '23.4375rem' }"
                      [itemSize]="75"
                      (scrolledIndexChange)="attachmentScrolledIndexChanged($event)"
                    >
                      <div
                        role="button"
                        tabindex="0"
                        *cdkVirtualFor="let file of attachments"
                        (mouseenter)="onMouseEnter(file)"
                        (mouseleave)="onMouseLeave()"
                        (focus)="onMouseEnter(file)"
                        (click)="goToAttachmentMessage(file)"
                        (keydown.enter)="onAttachmentRowKeydown($event, file)"
                        (keydown.space)="onAttachmentRowKeydown($event, file)"
                        [attr.aria-label]="getAttachmentDisplayName(file) + ', ' + ('cl_chat.goToMessage' | translate)"
                        data-e2e="info-selected-attachment"
                        class="relative flex flex-row items-center cursor-pointer bg-content-background h-[65px] w-[346px] mt-[10px] mr-[24px] ml-[21px] rounded-2xl border border-surface-200 dark:border-surface-700 hover:bg-primary/5 focus-visible:outline-none focus-visible:shadow-[0_0_0_3px_rgba(0,115,208,0.24)]"
                      >
                        @if (moreOptionsSelected(file) || isHovered(file)) {
                          <div
                            class="cursor-default z-[2] h-9 bg-surface-0 dark:bg-surface-800 border border-surface-100 dark:border-surface-700 absolute right-[9px] -top-2 shadow-[8px_8px_24px_rgba(166,180,200,0.72),_-8px_-8px_16px_rgba(255,255,255,0.72)] dark:shadow-[0_4px_16px_rgba(0,0,0,0.4)] rounded-[17px] flex flex-row items-center"
                            (click)="stopEvent($event)"
                            (mouseenter)="mouseEnterOptionsArea($event)"
                            (mouseleave)="mouseLeaveOptionsArea($event)"
                            data-e2e="info-attachment-options"
                          >
                            <button
                              class="border-none bg-transparent mx-[10px] relative box-content min-w-6 min-h-6 flex items-center justify-center focus-visible:rounded-[3px] focus-visible:shadow-[0_0_0_3px_rgba(0,115,208,0.24)]"
                              [attr.aria-label]="'cl_chat.download' | translate"
                              data-e2e="info-attachment-download"
                              (click)="downloadAttachment(file, $event)"
                              (keydown.enter)="downloadAttachment(file, $event)"
                              [pTooltip]="'cl_chat.download' | translate"
                              tooltipPosition="top"
                            >
                              <i class="mi2-download text-[12px] text-surface-950 dark:text-surface-0 ml-2"></i>
                            </button>
                            @if (showPreviewMessageOptions(file)) {
                              <button
                                class="border-none bg-transparent mx-[10px] relative box-content min-w-6 min-h-6 flex items-center justify-center focus-visible:rounded-[3px] focus-visible:shadow-[0_0_0_3px_rgba(0,115,208,0.24)]"
                                appDebounceClick
                                [attr.aria-label]="'cl_chat.preview' | translate"
                                data-e2e="info-attachment-full-screen"
                                (debounceClick)="fullScreenPreview(file)"
                                [pTooltip]="'cl_chat.preview' | translate"
                                tooltipPosition="top"
                              >
                                <i class="mi2-visibility-on text-sm text-surface-950 dark:text-surface-0"></i>
                              </button>
                            }
                            @if (showMoreAttachmentOptions(file)) {
                              <button
                                class="border-none bg-transparent mx-[10px] relative box-content min-w-6 min-h-6 flex items-center justify-center focus-visible:rounded-[3px] focus-visible:shadow-[0_0_0_3px_rgba(0,115,208,0.24)]"
                                [attr.aria-label]="'cl_chat.more' | translate"
                                data-e2e="info-attachment-options-more"
                                id="attachment-options-more"
                                (click)="showMoreDropDown(file, $event)"
                                (keydown.enter)="showMoreDropDown(file, $event)"
                                [pTooltip]="'cl_chat.more' | translate"
                                tooltipPosition="top"
                              >
                                <i class="mi2-more-vertical text-[12px] text-surface-950 dark:text-surface-0 ml-2"></i>
                              </button>
                            }
                          </div>
                        }
                        @if (moreOptionsSelected(file)) {
                          <div
                            class="w-[174px] h-fit rounded-lg bg-surface-0 dark:bg-surface-800 absolute z-[2] top-[19px] right-[17px] shadow-[0_0_16px_rgba(0,0,0,0.12)] border border-surface-200 dark:border-surface-700"
                          >
                            @if (showDelete()) {
                              <div
                                role="button"
                                data-e2e="info-attachment-options-delete"
                                tabindex="0"
                                class="flex items-center h-[35px] pl-[17px] text-sm cursor-pointer text-[var(--p-text-danger)] hover:bg-surface-50 dark:hover:bg-surface-800 first:rounded-t-lg last:rounded-b-lg [&:not(:last-child)]:border-b [&:not(:last-child)]:border-surface-300 dark:[&:not(:last-child)]:border-surface-600 focus-visible:shadow-[0_0_0_3px_rgba(0,115,208,0.24)]"
                                (click)="deleteAttachment(file, $event)"
                                (keydown.enter)="deleteAttachment(file, $event)"
                                (keydown.space)="$event.preventDefault(); deleteAttachment(file, $event)"
                                (mouseenter)="mouseEnterOptionsArea($event)"
                                (mouseleave)="mouseLeaveOptionsArea($event)"
                                (blur)="focusOutOptionsArea($event)"
                              >
                                <span>{{ 'cl_chat.deleteMessage' | translate }}</span>
                              </div>
                            }
                          </div>
                        }
                        <div class="shrink-0 mx-[14px]">
                          <mi-attachment-icon [attachmentName]="file.name" class="[zoom:88%]"></mi-attachment-icon>
                        </div>
                        <div class="grow overflow-hidden pr-[14px] text-left">
                          <div
                            class="text-base truncate text-color pb-[2px] font-bold"
                            title="{{ getAttachmentDisplayName(file) }}"
                          >
                            {{ getAttachmentDisplayName(file) }}
                          </div>
                          <div class="text-sm text-muted-color font-semibold">
                            {{ 'cl_chat.fileSize' | translate }}: {{ getFileSize(file) }}
                          </div>
                          <div
                            class="pt-1 text-sm font-semibold truncate text-muted-color"
                            [pTooltip]="file.createdOn | chatDate: translate.currentLang : config()?.showDayOfWeek"
                            tooltipPosition="top"
                          >
                            {{
                              'cl_chat.attachmentDate'
                                | translate
                                  : {
                                      date: file?.dateString,
                                      user: chatAdminService.displayNames[file?.createdBy] || file?.createdBy
                                    }
                            }}
                          </div>
                        </div>
                      </div>
                    </cdk-virtual-scroll-viewport>
                  }
                </div>
              }
              <!-- generics -->
              @if (
                i === 2 &&
                selectedConfig()?.genericAttribute === 'chat-info-generic-1' &&
                selectedConfig()?.type === buttonTypes.GENERIC
              ) {
                <ng-content select="[chat-info-generic-1]"></ng-content>
              }
              @if (
                i === 3 &&
                selectedConfig()?.genericAttribute === 'chat-info-generic-2' &&
                selectedConfig()?.type === buttonTypes.GENERIC
              ) {
                <ng-content select="[chat-info-generic-2]"></ng-content>
              }
              @if (
                i === 4 &&
                selectedConfig()?.genericAttribute === 'chat-info-generic-3' &&
                selectedConfig()?.type === buttonTypes.GENERIC
              ) {
                <ng-content select="[chat-info-generic-3]"></ng-content>
              }
              @if (
                i === 5 &&
                selectedConfig()?.genericAttribute === 'chat-info-generic-4' &&
                selectedConfig()?.type === buttonTypes.GENERIC
              ) {
                <ng-content select="[chat-info-generic-4]"></ng-content>
              }
              @if (
                i === 6 &&
                selectedConfig()?.genericAttribute === 'chat-info-generic-4' &&
                selectedConfig()?.type === buttonTypes.GENERIC
              ) {
                <ng-content select="[chat-info-generic-5]"></ng-content>
              }
              <!-- expanded notifications list -->
              @if (b.type === buttonTypes.NOTIFICATIONS && selectedConfig()?.type === buttonTypes.NOTIFICATIONS) {
                <div class="notifications-container">
                  @if (config()?.isOneAppSettingsError) {
                    <div #oneAppSettingsError class="settings-load-error" role="alert">
                      <i class="mi2-error text-[14px] text-red-700 mr-1"></i>
                      <div [innerHtml]="this.translate.instant('cl_chat.errorLoadingSettingsPleaseReload')"></div>
                    </div>
                  }
                  @if (!config()?.isOneAppSettingsError && conversationLoaded()) {
                    <div>
                      <div class="notifications-title">
                        {{ getNotificationsStatus() }}
                        @if (notificationsEnabled()) {
                          <i class="mi2-notifications-on text-[23px] text-green-700 ml-1"></i>
                        } @else {
                          <i class="mi2-notifications-off text-[23px] text-red-700 ml-1"></i>
                        }
                      </div>
                      <!-- disable/enable notifications for streams -->
                      @if (isStream()) {
                        <button
                          [attr.data-e2e]="notificationsEnabled() ? 'info-disable' : 'info-enable'"
                          class="chat-one-app-button modal-button"
                          [ngClass]="notificationsEnabled() ? 'primary-red' : 'primary-grey'"
                          (click)="optInOrOut()"
                          [disabled]="
                            !notificationsEnabled() &&
                            _notificationSettingsValue.optedInStreams.length > config()?.maxNotificationSettings - 1
                          "
                        >
                          {{
                            notificationsEnabled()
                              ? translate.instant('cl_chat.disable')
                              : translate.instant('cl_chat.enable')
                          }}
                        </button>
                      }
                      <!--  disable/enable notifications for DM's -->
                      @if (!isStream() && !alwaysMuted()) {
                        <button
                          #muteMenuBtn
                          type="button"
                          data-e2e="dropdown-list"
                          class="dm-mute-options bg-surface-0 dark:bg-surface-800 border border-surface-200 dark:border-surface-700 backdrop-blur-sm rounded-lg text-base h-10 p-0 flex justify-between items-center w-[290px] cursor-pointer disabled:opacity-70 disabled:cursor-default focus-visible:outline-none focus-visible:shadow-[0px_0px_0px_3px_rgba(0,115,208,0.24)]"
                          style="color: var(--p-text-danger)"
                          [attr.aria-haspopup]="true"
                          [attr.aria-expanded]="muteMenu.isOpen"
                          [disabled]="
                            (notificationsEnabled() &&
                              _notificationSettingsValue.mutedDirects.length > config()?.maxNotificationSettings - 1) ||
                            !notificationsEnabled()
                          "
                          (click)="muteMenu.toggle(muteMenuBtn); onMuteMenuToggle(muteMenuBtn, muteMenu)"
                        >
                          <span class="px-4 truncate">{{ getMuteDropdownPrefix() }}</span>
                          <i
                            class="mi2-down-arrow-filled text-sm mr-4 transition-transform duration-200 ease-in-out"
                            [ngClass]="{ 'rotate-180': muteMenu.isOpen }"
                          ></i>
                        </button>
                        <mi-menu #muteMenu [items]="getMuteMenuItems()"></mi-menu>
                      }
                      @if (!isStream() && !notificationsEnabled()) {
                        <button data-e2e="info-unmute" class="unmute-dm-button primary-grey" (click)="unmuteDM()">
                          {{ 'cl_chat.unmute' | translate }}
                        </button>
                      }
                      <div class="notifications-note">
                        <span>{{ 'cl_chat.note' | translate }}: </span>
                        <div [innerHTML]="getNotificationsNote()"></div>
                        <div [innerHTML]="getWorkingOn()"></div>
                      </div>
                      <div class="notifications-settings">
                        <span [innerHTML]="translate.instant('cl_chat.youCanChangeSettings')"></span>
                        <button
                          data-e2e="info-preferences"
                          class="preferences-button"
                          (click)="preferencesClick()"
                          (keydown.enter)="preferencesClick()"
                        >
                          {{ 'cl_chat.preferences' | translate | lowercase }}
                        </button>
                      </div>
                    </div>
                  }
                </div>
              }
            </p-accordion-content>
          </p-accordion-panel>
        }
      </p-accordion>
    }
    <!-- action buttons -->
    @if (actions()) {
      <div class="flex flex-col justify-end items-center w-full grow pb-[6px]">
        <!-- Extra div: no styling, added to address misalignment in iOS WebView -->
        <div class="inline-flex flex-col mx-[16px]">
          @for (a of actions(); track a.key; let i = $index) {
            <p-button
              class="block"
              [style]="{ 'background-color': a.color }"
              styleClass="flex text-[14px] font-semibold !text-white uppercase !p-[10px] !border-none rounded-[25px] w-full min-h-[40px] items-center justify-center my-[4px] hover:opacity-80 focus-visible:outline-none focus-visible:shadow-[0_0_0_3px_rgba(0,115,208,0.24)]"
              [label]="a.title"
              (onClick)="actionClick(a.key)"
              [attr.data-e2e]="'info-action-' + a.key | slugify"
            >
              @if (a?.imgSrc) {
                <img src="{{ a.imgSrc }}" alt="" class="w-6 h-6 object-contain mr-1" />
              } @else if (a?.icon) {
                <i class="{{ a.icon }} text-[24px] mr-1"></i>
              }
            </p-button>
          }
        </div>
      </div>
    }
  </div>
</div>
